export default {
  TABOPENED: 'TABOPENED',
  POPUPCLOSED: 'POPUPCLOSED',
  DEFAULTSEARCHPAGE: 1,
  PERPAGE: 15,
  CLAUTOCOMPLELIMIT: 5,
  DEFAULTFILTER: 'all',
  CONTACT_EMAIL: 'info@neurochecklists.com'
}
